/**
 * RunStatusBadge — small coloured pill for run lifecycle states.
 *
 * Used on the pipeline page and in dashboard cards to surface
 * running / success / partial / failed / skipped / idle states.
 */

type RunStatus =
  | "idle"
  | "running"
  | "success"
  | "partial"
  | "failed"
  | "skipped";

interface RunStatusBadgeProps {
  status: RunStatus;
}

const STATUS_LABEL: Record<RunStatus, string> = {
  idle: "Idle",
  running: "Running",
  success: "Success",
  partial: "Partial",
  failed: "Failed",
  skipped: "Skipped",
};

const STATUS_CLASS: Record<RunStatus, string> = {
  idle: "run-badge--idle",
  running: "run-badge--running",
  success: "run-badge--success",
  partial: "run-badge--partial",
  failed: "run-badge--failed",
  skipped: "run-badge--skipped",
};

export function RunStatusBadge({ status }: RunStatusBadgeProps) {
  return (
    <span
      className={`run-badge ${STATUS_CLASS[status]}`}
      aria-label={`Status: ${STATUS_LABEL[status]}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
